import { render, staticRenderFns } from "./BuyDirect.vue?vue&type=template&id=b02a24d0&scoped=true"
import script from "./BuyDirect.vue?vue&type=script&lang=js"
export * from "./BuyDirect.vue?vue&type=script&lang=js"
import style0 from "./BuyDirect.vue?vue&type=style&index=0&id=b02a24d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02a24d0",
  null
  
)

export default component.exports